var render = function render(_c,_vm){return (_vm.props.file && _vm.props.file.SUBDIR && _vm.props.file.FILE_NAME)?_c('v-img',_vm._g(_vm._b({attrs:{"src":_vm.$options.methods.getSrc(_vm.props.file)}},'v-img',_vm.data.attrs,false),_vm.listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }